export function shipmentTooltip() {
  const tooltipTrigger = document.querySelector('.price-article .prc-detail-info');
  if (tooltipTrigger) {
    const tooltip = tooltipTrigger.querySelector('.tooltipbox');
    const closeTooltip = () => {
      tooltip && tooltip.classList.remove('show');
    }

    tooltipTrigger.querySelector('span').addEventListener('click', () => {
      tooltip && tooltip.classList.toggle('show');
      document.body.addEventListener('click', closeTooltip, true);
    });
  }
}export function installationTooltip() {
  const tooltipTrigger = document.querySelector('.pda-cta-price .installation-included > p');
  if (tooltipTrigger) {
    const tooltip = document.querySelector('.pda-cta-price .installation-included .tooltipbox');
    const closeTooltip = () => {
      tooltip && tooltip.classList.remove('show');
    }
    const tooltipClose = tooltip.querySelector('.tooltip-close');

    tooltipTrigger.addEventListener('click', () => {
      tooltip && tooltip.classList.toggle('show');
      document.body.addEventListener('click', closeTooltip, true);
    });
    tooltipClose.addEventListener('click', function () {
      tooltip && tooltip.classList.remove('show');
    })
  }
}